<template>
  <div class="manage_web">
    <div class="manage_btn"
         v-if="false"></div>
    <div class="manage_main">
      <div class="manage_main_view">
        <el-button @click='addWebsite'
                   size="mini"
                   type="success">
          添加网站
        </el-button>
      </div>
      <!-- <marquee direction="left">这是一段内容</marquee> -->
      <div>

      </div>
      <el-table :data="tableData"
                max-height="600px"
                style="width: 100%">
        <el-table-column type="selection"
                         width="55">
        </el-table-column>
        <el-table-column prop="title"
                         label="网站名"
                         width="150">

        </el-table-column>
        <el-table-column prop="bindhost"
                         label="域名"
                         width="200">
        </el-table-column>
        <el-table-column prop="click"
                         label="访问量"
                         width="100"
                         sortable>
        </el-table-column>
        <el-table-column prop="site_info.companySite"
                         label="公司地址"
                         width="200">
        </el-table-column>
        <el-table-column prop="site_info.contactNumber"
                         label="联系电话"
                         width="150">
        </el-table-column>

        <el-table-column>
          <template slot="header">
            <div class="title_view">
              <span>操作</span>
            </div>
          </template>
          <template slot-scope="scope">
            <el-button @click='skipWebInfp(scope.row.id)'
                       size="mini"
                       type="primary">
              编辑
            </el-button>
            <el-button @click="blockUp(scope.row.id,scope.row.status==0?'1':'0')"
                       size="mini"
                       :type="scope.row.status==0?'success':'danger'">
              {{scope.row.status==0?'开启':'关闭'}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { apiGetMarketing, apiSwitch, apiSubmitMarketing } from '@/request/api'
export default {
  data () {
    return {
      tableData: [],
      // 是否创建成功
      isEstablishSuccess: false
    }
  },
  methods: {
    async addWebsite () {
      this.$prompt('请输入绑定的域名', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async ({ value }) => {
        let res = await apiSubmitMarketing({
          mode: value ? 2 : 1,
          uid: this.$store.state.uid,
          bindhost: value || `http://${this.$store.state.uid}.tywl99.com`
        })
        if (res.errno == 0) {
          this.$message(res.message)
          setTimeout(() => {
            location.reload()
          }, 1000);
          this.isEstablishSuccess = true
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    // ---------------------开启，关闭网站----------------------
    async blockUp (siteid, status) {
      let res = await apiSwitch({
        siteid,
        status
      })
      if (res.errno == 0) {
        this.$message.success(status == 0 ? '网址关闭成功' : '网址开启成功')
        this.getAllWebInfo()
      }
    },
    // ---------------------进入营销网站编辑----------------------
    skipWebInfp (id) {
      this.$router.push({
        name: 'Marketing',
        query: {
          siteid: id
        }
      })
    },
    // ---------------------获取所有网站信息----------------------
    async getAllWebInfo () {
      let res = await apiGetMarketing({})
      console.log(res);
      if (res.errno == 0) {
        this.tableData = res.sitelist
      }
    }
  },
  created () {
    // ---------------------获取所有网站信息----------------------
    this.getAllWebInfo()


  }
}
</script>

<style lang='scss'>
.manage_web {
  width: 95%;
  height: 95%;
  // background-color: pink;
  position: relative;
  .cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .title_view {
    display: flex;
    // justify-content: flex-end;
    box-sizing: border-box;
    padding-right: 20px;
  }
  .manage_btn {
    width: 100%;
    height: 200px;
    // display: none;
    // background-color: pink;
  }
  .manage_main {
    // height: 100px;
    width: 100%;
    position: absolute;
    left: 0;
    top: 50px;
    bottom: 0px;
    min-height: 600px;
    .manage_main_view {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;
    }
    // background-color: rgb(168, 168, 245);
    .el-table {
      height: 100%;
    }
  }
}
</style>